import { useDispatch, useSelector } from "react-redux";

import CloseDetailPage from "../../components/CloseComponent/CloseDetailPage";
import { animatePageNotOpacity } from "../../animateConstant";
import { getFixedStyle } from "../../hook/useDeviceType";
import GetParams from "../../utils/getParams";
import { Base64 } from "js-base64";
import CommonBorder from "../../components/BorderComponent/CommonBorder";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import { HiChevronLeft } from "react-icons/hi";
import CloseComponent from "../../components/CloseComponent/CloseComponent";
import DetailWrapper from "../../components/detailWrapper";
import { Divider } from "semantic-ui-react";
import { useEffect, useState } from "react";
import { readInbox } from "../../api/postApi";
import { notice } from "../../redux/action/action";
import { isEmptyObject } from "../../utils/isEmptyObject";

const InboxDetail = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`inbox.${key}`);

  const navigate = useNavigate();

  const { inboxId } = useParams("inboxId");

  const [inboxDetail, setInboxDetail] = useState({
    subject: "",
    message: "",
    date: "",
    isInbox: 0,
  });
  const { subject, message, date, isInbox } = inboxDetail;

  const isInboxDetail = useSelector((state) => state.isInboxDetail);
  const dispatch = useDispatch();

  const safeDecodeURIComponent = (str) => {
    try {
      return decodeURIComponent(str);
    } catch (e) {
      if (e instanceof URIError) {
        console.error(e.message);
        return str;
      } else {
        throw e;
      }
    }
  };

  useEffect(() => {
    if (isInbox == 1) {
      readInbox({ inboxUid: inboxId }).then((data) => {});
    }
  }, [inboxId, isInbox]);

  useEffect(() => {
    if (!isEmptyObject(isInboxDetail)) {
      const subject = isInboxDetail?.subject;
      const message = safeDecodeURIComponent(isInboxDetail?.message);
      const date = isInboxDetail?.date;
      const isInbox = isInboxDetail?.isInbox == 1;
      setInboxDetail({
        subject,
        message,
        date,
        isInbox,
      });
    } else {
      navigate("../");
    }
  }, [isInboxDetail]);

  return (
    <DetailWrapper
      wrapperClassName={`h-full w-full md:absolute fixed top-0 left-0 max-h-full z-[1]`}
      closeAnimate
    >
      <CloseDetailPage
        hasPrev={
          <HiChevronLeft
            className="cursor-pointer"
            onClick={() => navigate("../")}
          />
        }
        title={i18n("title")}
      />
      <p className="text-base-light-dark dark:text-base-light-white text-xl font-medium mb-[10px]">
        {subject}
      </p>
      <Divider />
      <p className="text-light-text mb-[20px]">{date}</p>
      <div
        className="break-words font-medium text-light-text"
        dangerouslySetInnerHTML={{ __html: message }}
      ></div>
    </DetailWrapper>
  );
};

export default InboxDetail;
